import { changeDate } from "../../../../helpers/dayjsHelper";


export const itemsStepsAddList = [
    'Seleciona Espacios',
    'Seleciona Listas',
]

export const itemsSteps = [
    'Información',
    ...itemsStepsAddList
]

export const getFormInfo = (data) => {
    const {
        name = '',
        installedCapacity = 1,
        color = '#000000',
        year = new Date().getFullYear(),
        lists = [],
        type = 'section'
    } = data;

    const dateFormat = new Date(`${year}-03-01`)
    const yearChange = changeDate(dateFormat)

    const infoForm = {
        name,
        year: yearChange.day,
        installed_capacity: installedCapacity,
        type,
        spaces: [],
        lists: [],
        listsRemove: []
    }

    return {
        infoForm,
        color,
        lists
    }
}

export const getOptionsSelect = (data) => {
    return data.map((item) => ({
        value: item.id,
        label: item.name,
        className: `text-[8px] md:text-[12px]`
    }))
}

export const getItemByCascader = ({ name, clickupId }) => ({ label: name, value: clickupId })

export const getItemFolder = ({ name, lists }, index) => ({
    label: name,
    value: name,
    children: lists.map((list) => getItemByCascader(list))
})

export const getOptionsCascader = (data) => data.map((item, index) => {
    const listChild = item.listNotFolder.map((list) => getItemByCascader(list))
    const listChildFolder = item.folderList.map((folder) => getItemFolder(folder))
    return {
        label: item.name,
        value: index,
        children: [
            ...listChild,
            ...listChildFolder
        ]
    }
})

export const findClickupItem = (lists, clickupID, listLength) => {
    for (const item of lists) {
        if (listLength === 2) {
            const found = item.listNotFolder.find((subItem) => subItem.clickupId === clickupID)
            if (found) return found
        } else if (listLength === 3) {
            for (const folder of item.folderList) {
                const found = folder.lists.find((subItem) => subItem.clickupId === clickupID)
                if (found) return found
            }
        }
    }
    return null
}


export const getListAdd = (lists = [], listsClickup) => {
    return lists.reduce((acc, list) => {
        const clickupID = list[list.length - 1]
        const infoList = findClickupItem(listsClickup, clickupID, list.length)
        if (!infoList) return acc
        return [...acc, infoList]
    }, [])
}